<template lang="pug">
  section.section
    .page.container
      .events.columns.is-multiline
        .column.is-6(v-for="(model, key) in models", :key="key")
          .event
            router-link.image(:to="{ name: 'event-detail', params: { id: model._id }}")
              f-storage-image.image(:path="model.properties.thumbnailPath + '_p_512_____thumb.png'", ratio="56.25%")
            .detail
              router-link(:to="{ name: 'event-detail', params: { id: model._id }}")
                div.title {{ model.properties.name }}
                div.date
                  span(v-if="model.properties.startdate") {{ $textHelper.toThaiDate(model.properties.startdate)}} {{ ' ' }}
                  span(v-if="model.properties.enddate") - {{ $textHelper.toThaiDate(model.properties.enddate)}}
      infinite-loading(v-if="!isCallFirstLoad", @infinite='infiniteHandler')
</template>

<script>
import Node from '@/models/node'
import FStorageImage from '@/components/FStorageImage'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {
    FStorageImage,
    InfiniteLoading
  },
  data () {
    return {
      page: 1,
      models: {},
      isCallFirstLoad: true
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      Node.getAll('Event', { page: this.page, limit: 10, keyword: '', order: 'startdate DESC' })
        .then((models) => {
          this.models = models
          this.page = this.page + 1
          this.isCallFirstLoad = false
        })
    },
    infiniteHandler ($state) {
      Node.getAll('Event', { page: this.page, limit: 10, keyword: '', order: 'startdate DESC' })
        .then((models) => {
          if (models && models.length > 0) {
            this.models = this.models.concat(models)
            this.page = this.page + 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .page{
  }
  .event {
    display: block;
    color: white;
    background: white;
    height: 100%;
    .image {
      background: #ccc;
      position: relative;
    }
    .detail {
      padding: 20px 10px;
      background-color: white;
      display: block;
      a {
        color: black;
      }
      .title {
        font-size: 18px;
        margin: 0;
        min-height: 40px;
      }
      .date {
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/event/Index.vue